import { hasCondition } from './conditions';
import type { Combatant, DamageResult } from './types';

export function modifyDamage(target: Combatant, amount: number, type: string): DamageResult {
  const rawAmount = Math.max(0, Math.floor(amount));
  if (target.immunities.damage.includes(type)) {
    return { rawAmount, finalAmount: 0, type, modifier: 'immune' };
  }
  const vulnerable = target.vulnerabilities.damage.includes(type);
  const resistant = target.resistances.damage.includes(type) || hasCondition(target, 'petrified');
  if (vulnerable && !resistant) {
    return { rawAmount, finalAmount: rawAmount * 2, type, modifier: 'vulnerable' };
  }
  if (resistant && !vulnerable) {
    return { rawAmount, finalAmount: Math.floor(rawAmount / 2), type, modifier: 'resistant' };
  }
  return { rawAmount, finalAmount: rawAmount, type, modifier: 'normal' };
}

export function applyHpDelta(combatant: Combatant, delta: number): Combatant {
  if (delta >= 0) {
    return { ...combatant, hpCurrent: Math.min(combatant.hpMax, combatant.hpCurrent + delta) };
  }
  let incoming = Math.abs(delta);
  const tempSpent = Math.min(combatant.tempHp, incoming);
  incoming -= tempSpent;
  return {
    ...combatant,
    tempHp: combatant.tempHp - tempSpent,
    hpCurrent: Math.max(0, combatant.hpCurrent - incoming),
  };
}

export function setTempHp(combatant: Combatant, amount: number): Combatant {
  return { ...combatant, tempHp: Math.max(0, Math.floor(amount)) };
}

export function applyExhaustionHpCap(combatant: Combatant, level: number): Combatant {
  const hpMax = level >= 4 ? Math.floor(combatant.baseMaxHp / 2) : combatant.baseMaxHp;
  return { ...combatant, hpMax, hpCurrent: Math.min(combatant.hpCurrent, hpMax) };
}
